export default "//cdn.scentbird.com/assets/frontbird-site/images/orange-grove_f0b2ee.jpg";